export default __webpack_public_path__ + "static/media/logo.82d3eed8.png";